// Eprofishing – thumbnail -> variant (change colour only, keep size/length)
document.addEventListener('DOMContentLoaded', function () {
  // Empire product sections
  var productSections = document.querySelectorAll('[data-section-type="product"]');
  if (!productSections.length) return;

  productSections.forEach(function (section) {
    // Thumbnails for this product – adapt selectors if needed
    var thumbs = section.querySelectorAll('[data-media-id], .product__thumb, .product-single__thumbnail');
    if (!thumbs.length) return;

    // --- Get product JSON for this section ---
    var jsonEl =
      section.querySelector('[data-product-json]') ||
      document.querySelector('#ProductJson-' + section.dataset.sectionId);

    if (!jsonEl) return;

    var productData;
    try {
      productData = JSON.parse(jsonEl.textContent || jsonEl.innerHTML);
    } catch (e) {
      return;
    }
    if (!productData || !productData.variants) return;

    // We assume option1 = size/length, option2 = colour.
    var SIZE_INDEX = 0; // 0-based index → option1

    // Helper: get current option values from the page
    function getCurrentOptions() {
      var options = [];

      // Empire OS2.0 often uses data-option-position
      var optionEls = section.querySelectorAll('[data-option-position]');
      if (optionEls.length) {
        optionEls.forEach(function (el) {
          var pos = parseInt(el.getAttribute('data-option-position'), 10) - 1;
          if (el.tagName === 'SELECT') {
            options[pos] = el.value;
          } else if ((el.type === 'radio' || el.type === 'checkbox') && el.checked) {
            options[pos] = el.value;
          }
        });
      } else {
        // Fallback for variant-radios style markup
        var fieldsets = section.querySelectorAll('fieldset[data-option-index]');
        fieldsets.forEach(function (fs) {
          var idxAttr = fs.getAttribute('data-option-index') || '';
          var pos = parseInt(idxAttr.replace('option', ''), 10) - 1;
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) options[pos] = checked.value;
        });
      }

      return options;
    }

    // Helper: actually select variant
    function selectVariant(variantId) {
      // Main select[name="id"]
      var masterSelect = section.querySelector('select[name="id"]');
      if (masterSelect) {
        masterSelect.value = String(variantId);
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Hidden input[name="id"] (some setups)
      var idInput = section.querySelector('input[name="id"][type="hidden"]');
      if (idInput) {
        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // --- Attach click handlers to thumbnails ---
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Get img element & media id
        var img = thumb.querySelector('img') || thumb;
        var mediaId =
          img.getAttribute('data-media-id') ||
          img.getAttribute('data-thumbnail-id') ||
          img.dataset.mediaId ||
          img.dataset.thumbnailId;

        if (!mediaId) return;

        var options = getCurrentOptions();
        if (!options || options.length === 0) return;

        var currentSize = options[SIZE_INDEX]; // Length/Weight now selected
        if (!currentSize) return;

        // Find variant with SAME size + SAME media id
        var matchedVariant = productData.variants.find(function (v) {
          var mediaMatch =
            (v.featured_media && String(v.featured_media.id) === String(mediaId)) ||
            (v.featured_image && String(v.featured_image.id) === String(mediaId));
          return mediaMatch && v.option1 === currentSize;
        });

        // If there is no variant with this size + image, do nothing
        if (!matchedVariant) return;

        // Select that variant → Colour changes, size stays the same
        selectVariant(matchedVariant.id);
      });
    });
  });
});
